import React, { useState, useEffect } from "react";

import { GetReportShifts } from "./../../api/report";
import { GetAcativeRestaurants } from "./../../api/restaurant";

const ReportShifts = ({ token }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [restaurantId, setRestaurantId] = useState(0);
  const [restaurantList, setRestaurantList] = useState([]);
  const [data, setData] = useState([]);

  const loading = async () => {
    try {
      const restsaurants = await GetAcativeRestaurants(token);
      setRestaurantList(restsaurants);
      let rests = {};
      for (let r of restsaurants) {
        rests[r.id] = r;
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loading();
  }, [token]);

  async function donwloadRepost() {
    const response = await GetReportShifts(
      token,
      startDate,
      endDate,
      restaurantId,
    );
    console.log(response);
    renderTable(response);
  }

  function renderTable(data) {
    const shifts = data.shifts;
    const ts = data.template_shifts;
    const fts = data.fts;
    const users = data.users;
    const rests = data.restaurants;
    if (ts.length == 0) {
      setData(
        <h1 className="text-center">Ну как ни странно, но тут пусто :)</h1>,
      );
      return;
    }
    let tables = [];
    console.log(data);
    // console.log(shifts, ts, fts);

    let restaurants = [];
    for (let t of ts) {
      if (!restaurants.includes(t.restaurant_id)) {
        restaurants.push(t.restaurant_id);
      }
    }
    for (let i = 0; i < restaurants.length; i++) {
      let rest = restaurants[i];
      let bk_hours = 0;
      let s_hours = 0;
      let ts_hours = 0;
      let s_count = 0;
      let ts_count = 0;
      let ft_count = 0;
      let s_period = 0;
      let s_period_ts = 0;
      let users_rest = 0;
      for (let u of users) {
        if (u == rest) {
          users_rest += 1;
        }
      }
      for (let t of ts) {
        if (t.restaurant_id == rest) {
          ts_hours += t.hours;
          ts_count += 1;

          let start = t.start;
          let end = t.end;

          if (end < start) {
            end += 24;
          }

          // Определяем границы периода 12-20 (12-20 в тех же "условных сутках")
          const periodStart = 12;
          const periodEnd = 20;

          // Находим пересечение смены с периодом
          const intersectionStart = Math.max(start, periodStart);
          const intersectionEnd = Math.min(end, periodEnd);

          // Если пересечение есть, возвращаем его длительность
          if (intersectionStart < intersectionEnd) {
            s_period_ts += intersectionEnd - intersectionStart;
          }
        }
      }
      for (let s of shifts) {
        if (s.restaurant_id == rest) {
          if (s.template_shift_id != null) {
            s_hours += s.hours;
            s_count += 1;
            if (s.bk_hours) {
              bk_hours += timeInHours(s.bk_hours);
            }
            if (s.bk_night_hours) {
              bk_hours += timeInHours(s.bk_night_hours);
            }

            let start = s.start;
            let end = s.end;

            if (end < start) {
              end += 24;
            }

            // Определяем границы периода 12-20 (12-20 в тех же "условных сутках")
            const periodStart = 12;
            const periodEnd = 20;

            // Находим пересечение смены с периодом
            const intersectionStart = Math.max(start, periodStart);
            const intersectionEnd = Math.min(end, periodEnd);

            // Если пересечение есть, возвращаем его длительность
            if (intersectionStart < intersectionEnd) {
              s_period += intersectionEnd - intersectionStart;
            }
          }
        }
      }
      for (let ts of fts) {
        if (ts.restaurant_id == rest) {
          ft_count += 1;
        }
      }
      console.log(s_period, s_period_ts, "ssss");
      const tableClass =
        i % 2 === 0
          ? "table table-bordered align-middle "
          : "table table-bordered align-middle table-secondary";

      tables.push(
        <table key={rest} className={tableClass}>
          <tbody>
            <tr>
              <td className="text-center" rowSpan={1}>
                Ресторан
              </td>
              <td className="text-center" rowSpan={2}></td>
              <td className="text-center" rowSpan={1} colSpan={2}>
                Деплоймент
              </td>
              <td className="text-center" rowSpan={1} colSpan={2}>
                Не закрыты
              </td>
              <td className="text-center" rowSpan={2}>
                FTR план период
              </td>
              <td className="text-center" rowSpan={2}>
                Бк часы
              </td>
              <td className="text-center" rowSpan={2}>
                FTR факт
              </td>
              <td className="text-center" rowSpan={2}>
                Full Time Кол-во, % от всех ЧК
              </td>
              <td className="text-center" rowSpan={2}>
                Кол-во часов с 12-20, % от всех часов
              </td>
            </tr>
            <tr>
              <td className="text-center" rowSpan={3}>
                {rests[rest]}
              </td>
              <td className="text-center" rowSpan={1}>
                План
              </td>
              <td className="text-center" rowSpan={1}>
                Факт
              </td>
              <td className="text-center" rowSpan={1}>
                Смены
              </td>
              <td className="text-center" rowSpan={1}>
                %
              </td>
            </tr>
            <tr>
              <td className="text-center" rowSpan={1}>
                Смены
              </td>
              <td className="text-center" rowSpan={1}>
                {ts_count}
              </td>
              <td className="text-center" rowSpan={1}>
                {s_count}
              </td>
              <td className="text-center" rowSpan={1}>
                {s_count - ts_count}
              </td>
              <td className="text-center" rowSpan={1}>
                {((s_count / ts_count - 1) * 100).toFixed(3)}
              </td>
              {/* % выше */}
              <td className="text-center" rowSpan={1}>
                {((s_count / ts_count) * 100).toFixed(3)}
              </td>
              {/* выше FTR план период */}
              <td className="text-center" rowSpan={2}>
                {bk_hours.toFixed(3)}
              </td>
              <td className="text-center" rowSpan={2}>
                {((bk_hours / s_hours) * 100).toFixed(3)}
              </td>
              <td className="text-center" rowSpan={1}>
                {ft_count}
              </td>

              <td className="text-center" rowSpan={1}>
                {s_period}
              </td>
            </tr>
            <tr>
              <td className="text-center">Часы</td>
              <td className="text-center">{ts_hours}</td>
              <td className="text-center">{s_hours}</td>
              <td className="text-center">{s_hours - ts_hours}</td>
              <td className="text-center">
                {((s_hours / ts_hours - 1) * 100).toFixed(3)}
              </td>
              <td className="text-center" rowSpan={1}>
                {((s_hours / ts_hours) * 100).toFixed(3)}
              </td>
              <td className="text-center" rowSpan={1}>
                {users_rest
                  ? ((ft_count / users_rest) * 100).toFixed(3)
                  : "Нет пользователей"}
                {/* {((ft_count / users_rest) * 100).toFixed(3)} */}
              </td>
              <td className="text-center">
                {/* {((s_period / s_hours) * 100).toFixed(3)} */}
                {((s_period / s_period_ts) * 100).toFixed(3)}
              </td>
            </tr>
          </tbody>
        </table>,
      );
    }

    setData(tables);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по сменам</h1>
        </div>

        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          {/* <div className="mb-3"> */}
          <label className="form-label">Начало периода</label>
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) => setStartDate(e.target.value)}
            value={startDate}
          />
          {/* </div> */}
        </div>
        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Конец периода</label>
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) => setEndDate(e.target.value)}
            value={endDate}
          />
        </div>
        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Ресторан</label>
          <select
            className="form-select"
            name=""
            id=""
            value={restaurantId}
            onChange={(e) => setRestaurantId(e.target.value)}
          >
            <option value="0">Все</option>
            {restaurantList.map((rest) => (
              <option value={rest.id} key={rest.id}>
                {rest.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3" style={{ marginTop: "5.8%" }}>
          <button className="btn" onClick={donwloadRepost}>
            Выгрузить
          </button>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        {data}
      </div>
      <div className="row" style={{ marginTop: "5%" }}></div>
    </div>
  );
};

export default ReportShifts;

function timeInHours(time) {
  let totalSeconds = 0;
  const [hours, minutes, seconds] = time.split(":").map(Number);
  totalSeconds += hours * 3600 + minutes * 60 + seconds;
  return totalSeconds / 3600;
}
